function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash/fp';

var fp = _.noConflict();

var mapWithKeys = fp.map.convert({
  cap: false
});
var mapValuesWithKeys = fp.mapValues.convert({
  cap: false
});
import Ncs from '../index';
import { selectByPattern } from '../tags';
var snapshotFields = ['type', 'distance', 'globalOptions', 'left', 'right'];

function toApiElements(elements, options) {
  var allFieldsEmpty = function allFieldsEmpty(e) {
    return fp.all(function (f) {
      return fp.isEmpty(f.value);
    })(e);
  };

  var filledElements = fp.filter(fp.negate(allFieldsEmpty))(elements);
  var formatFields = fp.pipe(fp.omit('category'), fp.mapValues(function (f) {
    return {
      value: f.value,
      options: options
    };
  }), fp.pickBy(function (f) {
    return !fp.isEmpty(f.value);
  }));
  var result = fp.map(formatFields)(filledElements); // Special case for tag field, which should have no options.
  // If there is another field with this behaviour, make this configurable.

  result = fp.map(function (e) {
    return e.tag ? _objectSpread({}, e, {
      tag: _objectSpread({}, e.tag, {
        options: undefined
      })
    }) : e;
  })(result);
  return result;
}

function setElementFieldAttr(state, _ref) {
  var side = _ref.side,
      index = _ref.index,
      field = _ref.field,
      attr = _ref.attr,
      value = _ref.value;
  var currentElement = state[side][index] || Ncs.config.elements.emptyElement();
  var currentField = currentElement[field] || {};

  var updatedElement = _objectSpread({}, currentElement, _defineProperty({}, field, _objectSpread({}, currentField, _defineProperty({}, attr, value))));

  state[side] = [].concat(_toConsumableArray(state[side].slice(0, index)), [updatedElement], _toConsumableArray(state[side].slice(index + 1)));
}

function escapeElement(element) {
  return mapValuesWithKeys(function (e, f) {
    if (f !== 'tag' && f !== 'category' && e.value) {
      return _objectSpread({}, e, {
        value: e.value.replace(/[!|*?]/g, function (e) {
          return "\\".concat(e);
        })
      });
    } else {
      return e;
    }
  })(element);
}

function tagToPattern(tag) {
  return tag.tagSelectorUsed === 'friendly' ? tag.value.join('|') : tag.pattern || tag.value;
}

function tagField(element, previous) {
  var tags = Ncs.config.tags.list;
  var result = {};

  if (fp.get('tag.value', element) && fp.getOr([], 'tag.value', previous).length > 0) {
    result.pattern = "".concat(tagToPattern(element.tag), "&").concat(tagToPattern(previous.tag));
    result.tagSelectorUsed = 'pattern';
    result.value = selectByPattern(result.pattern, tags);
  } else if (fp.get('category.value', element) && fp.getOr([], 'tag.value', previous).length > 0) {
    var categoryPattern = Ncs.config.categories.patterns[element.category.value];
    result.pattern = "".concat(categoryPattern, "&").concat(tagToPattern(previous.tag));
    result.tagSelectorUsed = 'pattern';
    result.value = selectByPattern(result.pattern, tags);
  } else if (fp.get('category.value', element)) {
    result.tagSelectorUsed = 'pattern';
    result.pattern = Ncs.config.categories.patterns[element.category.value];
    result.value = selectByPattern(Ncs.config.categories.patterns[element.category.value], tags);
  } else if (element.tag && fp.isString(element.tag.value)) {
    result.tagSelectorUsed = 'pattern';
    result.pattern = element.tag.value;
    result.value = selectByPattern(element.tag.value, tags);
  } else if (element.tag && fp.isArray(element.tag.value)) {
    result = element.tag;
  }

  return _objectSpread({}, previous.tag, {}, result);
}

function mergeElement(element, previous) {
  if (fp.isUndefined(element)) return previous;
  if (fp.isUndefined(previous)) return element;
  var merged = fp.merge(previous, element);
  return _objectSpread({}, merged, {
    tag: tagField(element, previous)
  });
}

export default {
  namespaced: true,
  state: {
    type: null,
    distance: {
      type: null,
      number: 1
    },
    defaultOptions: {},
    globalOptions: {},
    left: [],
    right: []
  },
  mutations: {
    // Sets ALL the elements at both sides.
    setElements: function setElements(s, m) {
      var empty = Ncs.config.elements.emptyElement;
      var left = m.escape ? fp.map(escapeElement, m.left) : m.left;
      var right = m.escape ? fp.map(escapeElement, m.right) : m.right;

      if (m.merge) {
        // Merge each element with previous element by position
        s.left = fp.map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              e = _ref3[0],
              p = _ref3[1];

          return mergeElement(e, p || empty());
        }, fp.zip(left, s.left));
        s.right = fp.map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              e = _ref5[0],
              p = _ref5[1];

          return mergeElement(e, p || empty());
        }, fp.zip(right, s.right));
      } else {
        s.left = fp.map(function (e) {
          return mergeElement(e, empty());
        }, left);
        s.right = fp.map(function (e) {
          return mergeElement(e, empty());
        }, right);
      }
    },
    setSearchType: function setSearchType(s, m) {
      if (m.type === s.type) {
        // When preserving same element type left side is preserved
        if (!m.distance && s.distance.type || m.distance && !s.distance.type) {
          // When changing from distance to elements or the reverse set empty right side.
          s.right = [Ncs.config.elements.emptyElement()];
        }
      } else {
        // When changing element type both sides are reset
        s.left = [Ncs.config.elements.emptyElement()];
        s.right = [Ncs.config.elements.emptyElement()];
      }

      s.type = m.type;
      s.distance.type = m.distance;
    },
    setDistance: function setDistance(s, m) {
      s.distance.type = m.type;
      s.distance.number = m.number;
    },
    addElement: function addElement(s, e) {
      s[e.side].splice(e.index, 0, Ncs.config.elements.emptyElement());
    },
    removeElement: function removeElement(s, e) {
      s[e.side].splice(e.index, 1);
    },
    setFieldValue: function setFieldValue(s, e) {
      return setElementFieldAttr(s, _objectSpread({}, e, {
        attr: 'value'
      }));
    },
    setFieldAttr: setElementFieldAttr,
    setDefaultOption: function setDefaultOption(s, o) {
      s.defaultOptions = _objectSpread({}, s.defaultOptions, _defineProperty({}, o.name, o.value));
      s.globalOptions = _objectSpread({}, s.globalOptions, _defineProperty({}, o.name, o.value));
    },
    setGlobalOption: function setGlobalOption(s, o) {
      s.globalOptions = _objectSpread({}, s.globalOptions, _defineProperty({}, o.name, o.value));
    },
    setAllGlobalOptions: function setAllGlobalOptions(s, v) {
      s.globalOptions = fp.mapValues(function (_) {
        return v;
      }, s.globalOptions);
    },
    reset: function reset(s, _ref6) {
      var type = _ref6.type,
          distance = _ref6.distance;
      s.type = type;
      s.distance = _objectSpread({}, distance);
      s.globalOptions = _objectSpread({}, s.defaultOptions);
      s.left = [Ncs.config.elements.emptyElement()];
      s.right = [Ncs.config.elements.emptyElement()];
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      s.type = v.type;
      s.distance.type = v.distance.type;
      s.distance.number = Number(v.distance.number);
      s.globalOptions = fp.defaults(s.defaultOptions)(v.globalOptions);
      s.left = v.left || [];
      s.right = v.right || [];
    }
  },
  getters: {
    at: function at(s) {
      return function (side, index) {
        return s[side][index];
      };
    },
    snapshot: function snapshot(s) {
      return fp.pick(snapshotFields)(s);
    },
    query: function query(s) {
      var options = fp.defaults(s.defaultOptions)(s.globalOptions);
      var result = {
        type: s.type,
        left: toApiElements(s.left, options)
      };

      if (s.distance.type) {
        return fp.merge(result)({
          distance: s.distance,
          right: toApiElements(s.right, options)
        });
      } else {
        return result;
      }
    }
  },
  actions: {
    setElements: function setElements(_ref7, m) {
      var commit = _ref7.commit;
      commit('setElements', m);
    },
    setSearchType: function setSearchType(_ref8, searchType) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch,
          commit = _ref8.commit,
          getters = _ref8.getters,
          rootGetters = _ref8.rootGetters,
          rootState = _ref8.rootState;
      dispatch('filters/resetElementFilters', state.type, {
        root: true
      });
      commit('setSearchType', searchType);
      var setup = Ncs.config.result[rootState.api.resultType].elements.setup;
      setup && setup(rootState, dispatch, Ncs.config);
      dispatch('order/setDefault', null, {
        root: true
      });
      dispatch('groups/setDefault', null, {
        root: true
      });
    },
    setDistance: function setDistance(_ref9, m) {
      var commit = _ref9.commit;
      commit('setDistance', m);
    },
    reset: function reset(_ref10) {
      var state = _ref10.state,
          dispatch = _ref10.dispatch,
          commit = _ref10.commit,
          getters = _ref10.getters,
          rootGetters = _ref10.rootGetters,
          rootState = _ref10.rootState;
      commit('reset', {
        type: Ncs.config.result[rootState.api.resultType].elements.defaultType,
        distance: Ncs.config.result[rootState.api.resultType].elements.defaultDistance || {
          type: null,
          number: 1
        }
      });
    }
  }
};